import { Component } from "react";
import GenAIDocumentData from "./GenAIDocumentData";
import { collapseIconNew, expandIconNew } from "../../assets";
import ActionBar from "../../components/ActionBar";
import "./GenAIDocumentCard.css"

class GenAIDocumentCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            actionBarCollapsed: false,
            documentIndex: this.props.count,
            showFilters: this.props.showFilters,
            item: [],
            customWidth: this.props.customWidth,
        }

    }
    componentDidMount() {
        this.setState({
            item: this.props.item,
            collapsed: this.props.globalCollapseAll,
            showFilters: this.props.showFilters,
        })
        //console.log(this.props.item);
        //console.log(this.state.item)
    }
    componentDidUpdate(prevProps) {
        if (this.props.globalCollapseAll !== prevProps.globalCollapseAll) {
            this.setState({ collapsed: this.props.globalCollapseAll })
        }
        if (this.props.showFilters !== prevProps.showFilters) {
            this.setState({ showFilters: prevProps.showFilters })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.collapsedAll !== undefined) {
            let data = this.props.collapsedAll;
            let index = this.props.resultsIndex;
            if (data[index]) {
                this.setState({ collapsed: data[index] })
            }
            else {
                this.setState({ collapsed: data[index] })
            }
        }
        if (this.state.customWidth !== nextProps.customWidth) {
            this.setState({ customWidth: nextProps.customWidth })
        }
    }
    handleExpandCollapse = () => {
        const collapsed = !this.state.collapsed;
        this.setState({ collapsed: !this.state.collapsed })
        if (window.location.pathname === '/pubMedResults') {
            this.props.manageCollapseAndExpand(collapsed, this.props.item.PMID)
        } else if (window.location.pathname === '/viewmarked' || window.location.pathname === '/old_viewmarked' || window.location.pathname === '/ViewSelectedReferencesUsed') {
            this.props.handlecollapsed()
        }
        else {
            this.props.manageCollapseAndExpand(collapsed, this.props.item.searchID)
        }


    }
    handelCitationSelect = (documentIndex, item, itemTeaser) => {
        // console.log(documentIndex)
        this.props.handleCitationSelection(documentIndex, item, itemTeaser);
    }
    handleUnpin = (item) => {
        this.props.handleUnpin(item);
    }
    citationUrl = (url) => {
        this.props.citationUrl(url)
    }
    renderGenAIDocumentData = () => {
        return (<GenAIDocumentData documentIndex={this.state.documentIndex}
            item={this.props.item}
            collapsed={this.state.collapsed}
            appliedFilters={this.props.appliedFilters}
            searchKeyword={this.props.searchKeyword}
            pageNumber={this.props.pageNumber}
            pageSize={this.props.pageSize}
            itemTeaser={this.props.itemTeaser}
            customWidth={this.state.customWidth}
            isCollapseAll={this.props.isCollapseAll}
            csPath={this.props.csPath}
            csproduct={this.props.csproduct}
            citationUrl={this.citationUrl}
            handleUnpin={this.handleUnpin}
            handelCitationSelect={this.handelCitationSelect}
            isChecked={this.props.isChecked}
            handleExpandCollapse={this.handleExpandCollapse}
            synonymsForDocumentPreview={this.props.synonymsForDocumentPreview}
            actionBarCollapsed={this.state.actionBarCollapsed}
            showFilters={this.state.showFilters}
            key={`GenAIDocumentData-${this.state.showFilters}`}
        />)
    }
    render() {
        let { showFilters } = this.state;
        return (
            <div className="doc-card">
                {showFilters ? <>{this.renderGenAIDocumentData()}</> : <>{this.renderGenAIDocumentData()}</>}
                {/* <div className="doc-card-inner">
                    <div className="doc-row header-row">
                        <div className="left-icons">
                            <div className="checkbox-outline" data-size="M" data-state="Enabled">
                                <div className="checkbox-border" />
                            </div>

                            <div className="small-square">
                                <div className="small-square-inner" />
                            </div>
                        </div>

                        <div className="doc-title">
                            ARN-809_IB_2023_ed19_PD_en_JNJ_6602897-AAA
                        </div>

                        <div className="action-icons">
                            <div className="icon-btn" data-property-1="Default">
                                <div className="icon-btn-inner">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_676_1771)">
                                            <path d="M1.61341 8.47543C1.52262 8.33167 1.47723 8.25979 1.45182 8.14892C1.43273 8.06565 1.43273 7.93431 1.45182 7.85104C1.47723 7.74017 1.52262 7.66829 1.61341 7.52453C2.36365 6.33654 4.59682 3.33331 8.00004 3.33331C11.4033 3.33331 13.6364 6.33654 14.3867 7.52453C14.4775 7.66829 14.5228 7.74017 14.5483 7.85104C14.5673 7.93431 14.5673 8.06565 14.5483 8.14892C14.5228 8.25979 14.4775 8.33167 14.3867 8.47543C13.6364 9.66342 11.4033 12.6666 8.00004 12.6666C4.59682 12.6666 2.36365 9.66342 1.61341 8.47543Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M8.00004 9.99998C9.10457 9.99998 9.99997 9.10455 9.99997 7.99998C9.99997 6.89541 9.10457 5.99998 8.00004 5.99998C6.89551 5.99998 6.00011 6.89541 6.00011 7.99998C6.00011 9.10455 6.89551 9.99998 8.00004 9.99998Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_676_1771">
                                                <rect width="15.9994" height="16" rx="4" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                </div>
                            </div>
                            <div className="icon-btn" data-property-1="Default">
                                <div className="icon-btn-inner">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.9996 10V10.8C13.9996 11.9201 13.9996 12.4802 13.7816 12.908C13.5899 13.2843 13.2839 13.5903 12.9076 13.782C12.4798 14 11.9198 14 10.7997 14H5.19989C4.07982 14 3.51979 14 3.09198 13.782C2.71567 13.5903 2.40972 13.2843 2.21798 12.908C2 12.4802 2 11.9201 2 10.8V10M11.333 6.66667L7.99979 10M7.99979 10L4.66657 6.66667M7.99979 10V2" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <div className="icon-btn" data-property-1="Default">
                                <div className="icon-btn-inner">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.99996 9.99998L7.99996 14.6666M5.33339 4.87207V6.29248C5.33339 6.43116 5.33339 6.5005 5.31978 6.56682C5.3077 6.62566 5.28773 6.6826 5.2604 6.73609C5.2296 6.79639 5.18629 6.85053 5.09966 6.95882L4.05317 8.26697C3.60936 8.82175 3.38746 9.09914 3.38721 9.33259C3.38699 9.53562 3.47929 9.72768 3.63796 9.85434C3.82041 9.99998 4.17563 9.99998 4.88607 9.99998H11.1139C11.8243 9.99998 12.1795 9.99998 12.362 9.85434C12.5206 9.72768 12.6129 9.53562 12.6127 9.33259C12.6125 9.09914 12.3906 8.82175 11.9467 8.26697L10.9003 6.95882C10.8136 6.85053 10.7703 6.79639 10.7395 6.73609C10.7122 6.6826 10.6922 6.62566 10.6801 6.56682C10.6665 6.5005 10.6665 6.43116 10.6665 6.29248V4.87207C10.6665 4.79532 10.6665 4.75694 10.6709 4.7191C10.6747 4.68548 10.6811 4.6522 10.69 4.61956C10.7001 4.58281 10.7143 4.54718 10.7428 4.47592L11.4147 2.79613C11.6107 2.30607 11.7087 2.06104 11.6679 1.86434C11.6321 1.69233 11.5299 1.54139 11.3835 1.44432C11.2161 1.33331 10.9522 1.33331 10.4244 1.33331H5.57555C5.04776 1.33331 4.78386 1.33331 4.61642 1.44432C4.46999 1.54139 4.3678 1.69233 4.33206 1.86434C4.29118 2.06104 4.38919 2.30607 4.58521 2.79613L5.2571 4.47592C5.2856 4.54718 5.29985 4.58281 5.30988 4.61956C5.31879 4.6522 5.3252 4.68548 5.32905 4.7191C5.33339 4.75694 5.33339 4.79532 5.33339 4.87207Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                            </div>
                            <div className="icon-btn" data-property-1="Default">
                                <div className="icon-btn-inner">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.8605 8.40495C14.0232 8.26545 14.1046 8.1957 14.1344 8.1127C14.1606 8.03985 14.1606 7.96017 14.1344 7.88732C14.1046 7.80432 14.0232 7.73457 13.8605 7.59507L8.21354 2.75466C7.93339 2.51453 7.79332 2.39446 7.67473 2.39152C7.57167 2.38896 7.47322 2.43425 7.40809 2.51416C7.33315 2.60612 7.33315 2.79061 7.33315 3.15959V6.0231C5.91008 6.27207 4.60764 6.99318 3.63975 8.07592C2.58453 9.25635 2.00082 10.784 2 12.3673V12.7753C2.69954 11.9326 3.57295 11.251 4.56042 10.7773C5.43101 10.3596 6.37212 10.1122 7.33315 10.047V12.8404C7.33315 13.2094 7.33315 13.3939 7.40809 13.4859C7.47322 13.5658 7.57167 13.6111 7.67473 13.6085C7.79332 13.6056 7.93339 13.4855 8.21354 13.2454L13.8605 8.40495Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                </div>
                            </div>
                            <div className="icon-btn" data-property-1="Default">
                                <div className="icon-btn-inner">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_676_1338)">
                                            <path d="M2.99986 14.6666V11.3333M2.99986 4.66665V1.33331M1.33325 2.99998H4.66647M1.33325 13H4.66647M8.66633 1.99998L7.51025 5.00589C7.32225 5.49471 7.22825 5.73912 7.08207 5.9447C6.95251 6.12691 6.79332 6.28611 6.61112 6.41567C6.40554 6.56185 6.16114 6.65585 5.67234 6.84386L2.66654 7.99998L5.67234 9.1561C6.16114 9.34411 6.40555 9.43811 6.61112 9.58429C6.79333 9.71385 6.95251 9.87305 7.08207 10.0553C7.22825 10.2608 7.32225 10.5053 7.51025 10.9941L8.66633 14L9.82241 10.9941C10.0104 10.5053 10.1044 10.2608 10.2506 10.0553C10.3801 9.87305 10.5393 9.71385 10.7215 9.58429C10.9271 9.43811 11.1715 9.34411 11.6603 9.1561L14.6661 7.99998L11.6603 6.84386C11.1715 6.65585 10.9271 6.56185 10.7215 6.41567C10.5393 6.28611 10.3801 6.12691 10.2506 5.9447C10.1044 5.73912 10.0104 5.49471 9.8224 5.00589L8.66633 1.99998Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_676_1338">
                                                <rect width="15.9994" height="16" rx="4" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="doc-row description-row">
                        <div className="description">
                            Learn everything about modern web development including React, TypeScript, and best practices for
                            building scalable applications. This comprehensive guide covers all aspects of frontend development....
                        </div>
                    </div>

                    <div className="doc-row meta-row">
                        <div className="meta-column">
                            <div className="meta-item">
                                <span className="meta-label">Authors: </span>
                                <span className="meta-value">Jon Doe, Jane Doe, Julia Doe</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Products: </span>
                                <span className="meta-value">TYLENOL</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Source: </span>
                                <span className="meta-value">Paedriatics Perinatal Epidemiology,2025.</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Document Type: </span>
                                <span className="meta-value">Publications</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Publication Status: </span>
                                <span className="meta-value">ePub</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Status: </span>
                                <span className="meta-value">Approved Effective</span>
                            </div>
                        </div>

                        <div className="meta-column">
                            <div className="meta-item">
                                <span className="meta-label">Primary Compound: </span>
                                <span className="meta-value">JNJ-66089745-AAA</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Generic Name: </span>
                                <span className="meta-value">apalutamide</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Page Count: </span>
                                <span className="meta-value">120</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Approved Date: </span>
                                <span className="meta-value">1-Apr-2023</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">Modified Date: </span>
                                <span className="meta-value">20-Sep-2025</span>
                            </div>

                            <div className="meta-item">
                                <span className="meta-label">System Version Number: </span>
                                <span className="meta-value">19.0</span>
                            </div>
                        </div>
                    </div>

                    
                    <div
                        className="action-badge"
                        data-color="Gray"
                        data-icon-left="true"
                        data-icon-right="false"
                        data-size="S"
                        data-style="Light background"
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_676_2117)">
                                <path d="M8.00016 10.6667V8.00001M8.00016 5.33334H8.00683M14.6668 8.00001C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8.00001C1.3335 4.31811 4.31826 1.33334 8.00016 1.33334C11.6821 1.33334 14.6668 4.31811 14.6668 8.00001Z" stroke="#81766F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_676_2117">
                                    <rect width="16" height="16" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                        <div className="badge-text">Order for RightFind for additional usage</div>
                    </div>
                </div> */}
            </div>
        );
        // return (
        //     <div className="resultsDetailsDivWrapper">
        //         <div /* style={{ width: this.props.customWidth <= 600 ? (this.props.customWidth < 450 ? "7%" : "5%") : "4%", float: "left", paddingTop: this.props.customWidth <= 800 ? (this.props.customWidth <= 600 ? "1%" : "0.8%") : "0.6%" }} */ className="resultDiv-left-outerwrapper">
        //             <span className="resultsDivLeftWrapper">
        //                 <input type="checkbox" value={this.state.item.docTitle} key={this.state.item.docID + Math.random()} onChange={() => this.handelCitationSelect(this.state.documentIndex, this.props.item, this.props.itemTeaser)} checked={this.props.isChecked} style={{ cursor: "pointer", width: "14px", height: "14px" }} /* class="k-checkbox" */ />
        //                 <img src={this.state.collapsed ? expandIconNew : collapseIconNew} alt="expand/collapse-icon" width={14} height={14} onClick={this.handleExpandCollapse} style={{ marginTop: this.props.customWidth < 600 ? "35%" : null, cursor: "pointer" }} />
        //             </span>
        //         </div>
        //         <div className="citation-outer-wrapper">
        //             <div style={{ float: "left", width: "100%" }}>
        //                 <DocumentData documentIndex={this.state.documentIndex} item={this.props.item} collapsed={this.state.collapsed} appliedFilters={this.props.appliedFilters} searchKeyword={this.props.searchKeyword} pageNumber={this.props.pageNumber} pageSize={this.props.pageSize} itemTeaser={this.props.itemTeaser} customWidth={this.props.customWidth} isCollapseAll={this.props.isCollapseAll} csPath={this.props.csPath} csproduct={this.props.csproduct} citationUrl={this.citationUrl} />
        //             </div>
        //         </div>
        //         <div className="results-div-action-bar-wrapper">
        //             <ActionBar actionBarCollapsed={this.state.actionBarCollapsed} item={this.props.item} appliedFilters={this.props.appliedFilters} searchKeyword={this.props.searchKeyword} pageNumber={this.props.pageNumber} pageSize={this.props.pageSize} handleSelect={this.handleToggleSelect} customWidth={this.props.customWidth} isCollapseAll={this.props.collapsed} collapsed={this.state.collapsed} csPath={this.props.csPath} csproduct={this.props.csproduct} handleUnpin={this.handleUnpin} synonymsForDocumentPreview={this.props.synonymsForDocumentPreview} />
        //         </div>
        //     </div>


        // )
    }

}
export default GenAIDocumentCard;